const ReleaseTypeEnum = {
  SINGLE: "SINGLE",
  ALBUM: "ALBUM",
  ALBUM_TRACK: "ALBUM_TRACK"
};
const parseReleaseType = enumParser(ReleaseTypeEnum);
const ArtistMintedReleasesCreditSplitFilterOptionEnum = {
  ALL: "ALL",
  ONLY_CREDIT_SPLITS: "ONLY_CREDIT_SPLITS",
  // only returns releases that has a respective credit split
  ONLY_NO_CREDIT_SPLITS: "ONLY_NO_CREDIT_SPLITS"
  // only returns releases without a respective credit split
};
const ArtistReleasesCreditSplitFilterOptionEnum = {
  ALL: "ALL",
  ONLY_CREDIT_SPLITS: "ONLY_CREDIT_SPLITS",
  // only returns releases that has a respective credit split
  ONLY_NO_CREDIT_SPLITS: "ONLY_NO_CREDIT_SPLITS"
  // only returns releases without a respective credit split
};
const ReleaseAlbumRevealFilterOptionEnum = {
  ALL: "ALL",
  ONLY_REVEALED_ALBUMS: "ONLY_REVEALED_ALBUMS",
  // only returns releases that have been revealed
  ONLY_NOT_REVEALED_ALBUMS: "ONLY_NOT_REVEALED_ALBUMS"
  // only returns releases that have not been revealed
};
const ArtistMintedReleasesAuthorFilterOptionEnum = {
  ALL: "ALL",
  ONLY_AUTHORED_RELEASES: "ONLY_AUTHORED_RELEASES",
  // author of the release
  ONLY_APPEARS_ON: "ONLY_APPEARS_ON"
  // has credit for the release but not the author
};
const ArtistReleasesAuthorFilterOptionEnum = {
  ALL: "ALL",
  ONLY_AUTHORED_RELEASES: "ONLY_AUTHORED_RELEASES",
  // author of the release
  ONLY_APPEARS_ON: "ONLY_APPEARS_ON"
  // has credit for the release but not the author
};
const ShelfTypeEnum = {
  DEFAULT: "DEFAULT",
  /** An auto-generated shelf that will contain all the releases user likes. */
  USER_LIKED_SOUNDS: "USER_LIKED_SOUNDS"
};
const ShelfTypeParser = enumParser(ShelfTypeEnum);
const LicenseTypeEnum = {
  CREATIVE_COMMONS: "CREATIVE_COMMONS",
  ALL_RIGHTS_RESERVED: "ALL_RIGHTS_RESERVED"
};
const isLicenseTypeEnum = enumChecker(LicenseTypeEnum);
const SongKeyEnum = {
  C_MAJOR: "C_MAJOR",
  G_MAJOR: "G_MAJOR",
  D_MAJOR: "D_MAJOR",
  A_MAJOR: "A_MAJOR",
  E_MAJOR: "E_MAJOR",
  B_MAJOR: "B_MAJOR",
  F_SHARP_MAJOR: "F_SHARP_MAJOR",
  D_FLAT_MAJOR: "D_FLAT_MAJOR",
  A_FLAT_MAJOR: "A_FLAT_MAJOR",
  E_FLAT_MAJOR: "E_FLAT_MAJOR",
  B_FLAT_MAJOR: "B_FLAT_MAJOR",
  F_MAJOR: "F_MAJOR",
  A_MINOR: "A_MINOR",
  E_MINOR: "E_MINOR",
  B_MINOR: "B_MINOR",
  F_SHARP_MINOR: "F_SHARP_MINOR",
  C_SHARP_MINOR: "C_SHARP_MINOR",
  G_SHARP_MINOR: "G_SHARP_MINOR",
  E_FLAT_MINOR: "E_FLAT_MINOR",
  B_FLAT_MINOR: "B_FLAT_MINOR",
  F_MINOR: "F_MINOR",
  C_MINOR: "C_MINOR",
  G_MINOR: "G_MINOR",
  D_MINOR: "D_MINOR"
};
const isSongKeyEnum = enumChecker(SongKeyEnum);
const AuctionTypeEnum = {
  RANGE_BOUND: "RANGE_BOUND",
  FIXED_QUANTITY: "FIXED_QUANTITY",
  OPEN_EDITION: "OPEN_EDITION",
  OPEN_EDITION_WITH_SAM: "OPEN_EDITION_WITH_SAM",
  FIXED_QUANTITY_WITH_GA: "FIXED_QUANTITY_WITH_GA",
  OPEN_EDITION_WITH_GA: "OPEN_EDITION_WITH_GA"
};
const TieredAuctionTypeEnum = {
  FIXED_QUANTITY: "FIXED_QUANTITY",
  OPEN_EDITION: "OPEN_EDITION",
  FIXED_QUANTITY_WITH_GA: "FIXED_QUANTITY_WITH_GA",
  OPEN_EDITION_WITH_GA: "OPEN_EDITION_WITH_GA"
};
const ArtistCommunityTypeEnum = {
  COLLECTORS: "COLLECTORS"
};
const AuctionTypeParser = enumParser(AuctionTypeEnum);
const ReleaseStatusEnum = {
  AVAILABLE_TO_MINT: "AVAILABLE_TO_MINT",
  SOLD_OUT: "SOLD_OUT",
  UPCOMING: "UPCOMING"
};
const RELEASE_STATUS_NAMES = Object.values(ReleaseStatusEnum);
const ShelfTypeFilterEnum = {
  ALL: "ALL",
  USER_CREATED: "USER_CREATED",
  LIKED: "LIKED"
};
const MintTimeStatusEnum = {
  PAST: "PAST",
  UPCOMING: "UPCOMING"
};
const MediaTypeEnum = {
  AUDIO: "AUDIO",
  AUDIO_128K: "AUDIO_128K",
  AUDIO_192K: "AUDIO_192K",
  AUDIO_HLS: "AUDIO_HLS",
  RELEASE_COVER_IMAGE: "RELEASE_COVER_IMAGE",
  // The original uploaded cover image or animation
  RELEASE_GA_COVER_IMAGE: "RELEASE_GA_COVER_IMAGE",
  // The original uploaded cover image or animation
  AUDIO_256K: "AUDIO_256K",
  RELEASE_WEB_ANIMATED_IMAGE: "RELEASE_WEB_ANIMATED_IMAGE",
  // web optimized animated image
  RELEASE_GA_WEB_ANIMATED_IMAGE: "RELEASE_GA_WEB_ANIMATED_IMAGE",
  // web optimized animated image
  RELEASE_WEB_STATIC_IMAGE: "RELEASE_WEB_STATIC_IMAGE",
  // web optimized static image supplied by artist. Only set if cover image is animated
  RELEASE_GA_WEB_STATIC_IMAGE: "RELEASE_GA_WEB_STATIC_IMAGE",
  // web optimized static image supplied by artist. Only set if cover image is animated
  RELEASE_WEB_STATIC_AUTOGEN_IMAGE: "RELEASE_WEB_STATIC_AUTOGEN_IMAGE",
  // web optimized static image auto-generated by transcoder. Only set if cover image is animated
  RELEASE_GA_WEB_STATIC_AUTOGEN_IMAGE: "RELEASE_GA_WEB_STATIC_AUTOGEN_IMAGE",
  // web optimized static image auto-generated by transcoder. Only set if cover image is animated
  RELEASE_BANNER_IMAGE: "RELEASE_BANNER_IMAGE",
  RELEASE_HOLDERS_CSV: "RELEASE_HOLDERS_CSV",
  RELEASE_GOLDEN_EGG_IMAGE: "RELEASE_GOLDEN_EGG_IMAGE",
  RELEASE_WEB_ANIMATED_GOLDEN_EGG_IMAGE: "RELEASE_WEB_ANIMATED_GOLDEN_EGG_IMAGE",
  // web optimized golden egg animated image
  ARTIST_BANNER_IMAGE: "ARTIST_BANNER_PHOTO",
  // We renamed this but it's still used in the database so we can't change it need to run migrations.
  ARTIST_FREE_SALE_ALLOWLIST: "ARTIST_FREE_SALE_ALLOWLIST",
  ARTIST_PRESALE_ALLOWLIST: "ARTIST_PRESALE_ALLOWLIST",
  ARTIST_COLLECTORS_CSV: "ARTIST_COLLECTORS_CSV",
  USER_BANNER_IMAGE: "USER_BANNER_IMAGE",
  AVATAR_IMAGE: "AVATAR_IMAGE",
  DRAFT_ALLOWLISTED_ADDRESSES_CSV: "DRAFT_ALLOWLISTED_ADDRESSES_CSV",
  TMP_AVATAR_AUTOGEN_IMAGE: "TMP_AVATAR_AUTOGEN_IMAGE",
  // temporary media type to convert existing gifs to stills for cutover. Will be deleted with https://linear.app/sound/issue/ENG-2154/clean-up-backfill-script-to-delete-temp-media-type-and-records
  TMP_ARTIST_BANNER_AUTOGEN_IMAGE: "TMP_ARTIST_BANNER_AUTOGEN_IMAGE",
  // temporary media type to convert gifs to stills. Will be deleted in clean up https://linear.app/sound/issue/ENG-2334/clean-up-cut-over-artifacts
  TMP_USER_BANNER_AUTOGEN_IMAGE: "TMP_USER_BANNER_AUTOGEN_IMAGE",
  // temporary media type type convert gifs to stills. Will be deleted in clean up https://linear.app/sound/issue/ENG-2334/clean-up-cut-over-artifacts
  SHELF_COVER_IMAGE: "SHELF_COVER_IMAGE",
  MERKLE_TREE_CSV: "MERKLE_TREE_CSV"
};
const TimePeriodAggEnum = {
  ALL_TIME: "ALL_TIME",
  ONE_DAY: "ONE_DAY",
  ONE_MONTH: "ONE_MONTH",
  SEVEN_DAY: "SEVEN_DAY"
};
const TopChartTimePeriodEnum = {
  ALL_TIME: "ALL_TIME",
  SEVEN_DAY: "SEVEN_DAY",
  THIRTY_DAY: "THIRTY_DAY"
};
const TrendingCollectorsSortEnum = {
  NFTS_BOUGHT: "NFTS_BOUGHT",
  CREATORS_SUPPORTED: "CREATORS_SUPPORTED",
  TOTAL_SPENT: "TOTAL_SPENT"
};
const TrendingPlaylistsSortEnum = {
  LIKES: "LIKES"
};
const TrendingReleasesSortEnum = {
  UNIQUE_COLLECTORS: "UNIQUE_COLLECTORS",
  NFTS_SOLD: "NFTS_SOLD",
  PRIMARY_SALES: "PRIMARY_SALES",
  SECONDARY_SALES: "SECONDARY_SALES",
  TOTAL_SALES: "TOTAL_SALES"
};
const TrendingArtistsSortEnum = {
  UNIQUE_COLLECTORS: "UNIQUE_COLLECTORS",
  NFTS_SOLD: "NFTS_SOLD",
  PRIMARY_SALES: "PRIMARY_SALES",
  SECONDARY_SALES: "SECONDARY_SALES",
  TOTAL_SALES: "TOTAL_SALES"
};
const EventTypeEnum = {
  TRANSFER: "TRANSFER",
  ORDERS_MATCHED: "ORDERS_MATCHED",
  EDITION_PURCHASED: "EDITION_PURCHASED",
  AIRDROP: "AIRDROP",
  OTHER_MINTED: "OTHER_MINTED",
  UNKNOWN: "UNKNOWN"
};
const parseEventType = enumParser(EventTypeEnum);
const MintingTypes = {
  FREE: "Free Mint",
  PRESALE: "Presale",
  FIXED: "Fixed",
  RANGE: "Range",
  OPEN_EDITION: "Open Edition"
};
const MintingAccessConfigMintingTypeEnum = {
  FREE: MintingTypes.FREE,
  PRESALE: MintingTypes.PRESALE
};
const parseMintingAccessConfigMintingType = enumParser(
  MintingAccessConfigMintingTypeEnum
);
const ContractTypeEnum = {
  ARTIST: "ARTIST",
  EDITION: "EDITION",
  TIERED_EDITION: "TIERED_EDITION"
};
const ContractProcessorTypeEnum = {
  SAM: "SAM",
  BASE_MINTER: "BASE_MINTER",
  BASE_MINTER_V2: "BASE_MINTER_V2",
  SUPER_MINTER: "SUPER_MINTER",
  MINTER_ADAPTER: "MINTER_ADAPTER",
  SOUND_CREATOR: "SOUND_CREATOR",
  SOUND_CREATOR_V2: "SOUND_CREATOR_V2",
  SOUND_EDITION: "SOUND_EDITION",
  SOUND_EDITION_V2: "SOUND_EDITION_V2"
};
const ReleaseActivityFeedTypeFilterOptionEnum = {
  ALL: "ALL",
  LIKES: "LIKES",
  PLAYLISTS: "PLAYLISTS",
  COLLECTIONS: "COLLECTIONS",
  RELEASES: "RELEASES",
  POSTS: "POSTS"
};
const ArtistActivityFeedTypeFilterOptionEnum = {
  ALL: "ALL",
  ARTIST: "ARTIST",
  // Actions performed by the artist
  RELEASE: "RELEASE",
  // Alias for 'Collector'
  COLLECTOR: "COLLECTOR"
  // Actions performed by collectors
};
const ArtistActivityFeedActivityTypeFilterOptionEnum = {
  ALL: "ALL",
  COLLECTIONS: "COLLECTIONS",
  // Actions related to collections
  PLAYLISTS: "PLAYLISTS",
  // Actions related to playlists
  LIKES: "LIKES",
  // Actions related to likes
  RELEASES: "RELEASES",
  // Actions related to releases (e.g., new drops)
  POSTS: "POSTS"
  // Actions related to posts
};
const ActivityFeedTypeEnum = {
  USER: "USER",
  GLOBAL: "GLOBAL",
  NOTABLE_COLLECTORS: "NOTABLE_COLLECTORS"
};
const ActivityFeedGroupComponentTypeEnum = {
  SONG_COLLECTED_BY_MANY: "SONG_COLLECTED_BY_MANY",
  // Primary sales only
  USER_COLLECTED_MANY_SONGS: "USER_COLLECTED_MANY_SONGS",
  // Primary sales only
  USER_PURCHASED_SECONDARY_MANY_SONGS: "USER_PURCHASED_SECONDARY_MANY_SONGS",
  SHELF_CREATED: "SHELF_CREATED",
  RELEASES_ADDED_TO_SHELF: "RELEASES_ADDED_TO_SHELF",
  RELEASE_DROPPED: "RELEASE_DROPPED",
  USER_LIKED_SONGS: "USER_LIKED_SONGS",
  USER_LIKED_PLAYLIST: "USER_LIKED_PLAYLIST",
  USER_CREATED_POST: "USER_CREATED_POST"
};
const parseActivityFeedGroupComponentType = enumParser(
  ActivityFeedGroupComponentTypeEnum
);
const ForYouFeedGroupComponentsFromUserFeed = [
  ActivityFeedGroupComponentTypeEnum.SONG_COLLECTED_BY_MANY,
  ActivityFeedGroupComponentTypeEnum.USER_COLLECTED_MANY_SONGS,
  ActivityFeedGroupComponentTypeEnum.USER_PURCHASED_SECONDARY_MANY_SONGS
];
const ActivityFeedGroupTypeFilterOptionEnum = {
  ALL: "ALL",
  COLLECTED: "COLLECTED",
  ADDED_TO_PLAYLIST: "ADDED_TO_PLAYLIST",
  RELEASE_DROPPED: "RELEASE_DROPPED",
  POSTS: "POSTS",
  LIKES: "LIKES"
};
const ACTIVITY_FEED_GROUP_FILTER_OPTION_TO_COMPONENT_TYPE = enumMapper({
  [ActivityFeedGroupTypeFilterOptionEnum.ALL]: [
    ActivityFeedGroupComponentTypeEnum.RELEASE_DROPPED,
    ActivityFeedGroupComponentTypeEnum.USER_COLLECTED_MANY_SONGS,
    ActivityFeedGroupComponentTypeEnum.USER_CREATED_POST
  ],
  [ActivityFeedGroupTypeFilterOptionEnum.RELEASE_DROPPED]: [
    ActivityFeedGroupComponentTypeEnum.RELEASE_DROPPED
  ],
  [ActivityFeedGroupTypeFilterOptionEnum.ADDED_TO_PLAYLIST]: [
    ActivityFeedGroupComponentTypeEnum.RELEASES_ADDED_TO_SHELF,
    ActivityFeedGroupComponentTypeEnum.SHELF_CREATED
  ],
  [ActivityFeedGroupTypeFilterOptionEnum.COLLECTED]: [
    ActivityFeedGroupComponentTypeEnum.USER_COLLECTED_MANY_SONGS
  ],
  [ActivityFeedGroupTypeFilterOptionEnum.LIKES]: [
    ActivityFeedGroupComponentTypeEnum.USER_LIKED_SONGS,
    ActivityFeedGroupComponentTypeEnum.USER_LIKED_PLAYLIST
  ],
  [ActivityFeedGroupTypeFilterOptionEnum.POSTS]: [
    ActivityFeedGroupComponentTypeEnum.USER_CREATED_POST
  ]
});
const RELEASE_TYPE_TO_CONTRACT_TYPE = {
  [ReleaseTypeEnum.SINGLE]: ContractTypeEnum.EDITION,
  [ReleaseTypeEnum.ALBUM]: ContractTypeEnum.EDITION,
  [ReleaseTypeEnum.ALBUM_TRACK]: ContractTypeEnum.EDITION
};
const ActivityFeedGroupInfoTypenames = {
  SongCollectedByManyAggregate: "SongCollectedByManyAggregate",
  UserCollectedManySongsAggregate: "UserCollectedManySongsAggregate",
  ShelfCreatedAggregate: "ShelfCreatedAggregate",
  ReleasesAddedToShelfAggregate: "ReleasesAddedToShelfAggregate",
  ReleaseDroppedAggregate: "ReleaseDroppedAggregate",
  UserLikedSongsAggregate: "UserLikedSongsAggregate",
  UserLikedPlaylistAggregate: "UserLikedPlaylistAggregate",
  UserCreatedPostAggregate: "UserCreatedPostAggregate"
};
const PostActionType = {
  USER_CREATED_POST: "USER_CREATED_POST",
  USER_CREATED_PLAYLIST_POST: "USER_CREATED_PLAYLIST_POST",
  USER_CREATED_ARTIST_DROP_POST: "USER_CREATED_ARTIST_DROP_POST",
  DELETED_POST: "DELETED_POST",
  USER_CREATED_POST_COMMENT: "USER_CREATED_POST_COMMENT",
  USER_CREATED_POST_COMMENT_REPLY: "USER_CREATED_POST_COMMENT_REPLY",
  DELETED_POST_COMMENT: "DELETED_POST_COMMENT",
  DELETED_POST_COMMENT_REPLY: "DELETED_POST_COMMENT_REPLY",
  UPVOTE_POST: "UPVOTE_POST",
  REPOST: "REPOST",
  UNDO_REPOST: "UNDO_REPOST",
  UPVOTE_POST_COMMENT: "UPVOTE_POST_COMMENT",
  REMOVE_VOTE: "REMOVE_VOTE",
  REMOVE_POST_COMMENT_VOTE: "REMOVE_POST_COMMENT_VOTE",
  // Admin
  ADMIN_DELETED_POST: "ADMIN_DELETED_POST",
  ADMIN_DELETED_POST_COMMENT: "ADMIN_DELETED_POST_COMMENT",
  ADMIN_DELETED_POST_COMMENT_REPLY: "ADMIN_DELETED_POST_COMMENT_REPLY",
  ADMIN_DISALLOW_USER_TO_POST: "ADMIN_DISALLOW_USER_TO_POST",
  ADMIN_ALLOW_USER_TO_POST: "ADMIN_ALLOW_USER_TO_POST"
};
const PostActionTypenames = {
  CreatedPost: "CreatedPost",
  // Generic post type
  CreatedPlaylistPost: "CreatedPlaylistPost"
  // Playlist post
};
const PlaylistActionType = {
  USER_LIKED_PLAYLIST: "USER_LIKED_PLAYLIST",
  USER_UNLIKED_PLAYLIST: "USER_UNLIKED_PLAYLIST",
  COPIED_RELEASES_TO_PLAYLIST: "COPIED_RELEASES_TO_PLAYLIST",
  BACKFILL_RELEASE_ADDED_TO_PLAYLIST: "BACKFILL_RELEASE_ADDED_TO_PLAYLIST",
  RECOVERED_PLAYLIST: "RECOVERED_PLAYLIST",
  CREATED_PLAYLIST: "CREATED_PLAYLIST",
  DELETED_PLAYLIST: "DELETED_PLAYLIST",
  ADDED_AND_REMOVED_RELEASE_FROM_PLAYLIST: "ADDED_AND_REMOVED_RELEASE_FROM_PLAYLIST",
  ADDED_RELEASES_TO_PLAYLIST: "ADDED_RELEASES_TO_PLAYLIST",
  REMOVED_RELEASES_FROM_PLAYLIST: "REMOVED_RELEASES_FROM_PLAYLIST"
};
const ArweaveActionType = {
  ARWEAVE_UPLOADED: "ARWEAVE_UPLOADED"
};
const ShelfActionType = {
  CREATED_SHELF: "CREATED_SHELF",
  EXTEND_SHELF: "EXTEND_SHELF",
  ADDED_RELEASE_TO_SHELF: "ADDED_RELEASE_TO_SHELF",
  BACKFILL_RELEASE_ADDED_TO_SHELF: "BACKFILL_RELEASE_ADDED_TO_SHELF",
  DELETED_SHELF: "DELETED_SHELF",
  RECOVERED_SHELF: "RECOVERED_SHELF",
  REMOVE_RELEASE_FROM_SHELF: "REMOVE_RELEASE_FROM_SHELF",
  // TODO: eng-2817 to be deleted after backfill
  ADDED_AND_REMOVED_RELEASE_FROM_SHELF: "ADDED_AND_REMOVED_RELEASE_FROM_SHELF",
  REMOVED_RELEASE_FROM_SHELF: "REMOVED_RELEASE_FROM_SHELF_V2"
  // TODO: eng-2817 Note this is distinct from the original singular `REMOVE_RELEASE_FROM_SHELF` which will be removed
};
const parseShelfActionType = enumParser(ShelfActionType);
const ExposedShelfActionType = {
  ["USER_LIKED_SHELF"]: "USER_LIKED_SHELF",
  [ShelfActionType.CREATED_SHELF]: ShelfActionType.CREATED_SHELF,
  [ShelfActionType.ADDED_RELEASE_TO_SHELF]: ShelfActionType.ADDED_RELEASE_TO_SHELF,
  [ShelfActionType.REMOVE_RELEASE_FROM_SHELF]: ShelfActionType.REMOVE_RELEASE_FROM_SHELF,
  [ShelfActionType.REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.REMOVED_RELEASE_FROM_SHELF,
  [ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF,
  [PostActionType.USER_CREATED_PLAYLIST_POST]: PostActionType.USER_CREATED_PLAYLIST_POST
};
const parseExposedShelfActionType = enumParser(ExposedShelfActionType);
const PurchaseActionTypenames = {
  PrimarySale: "PrimarySale",
  SecondarySale: "SecondarySale",
  Airdrop: "Airdrop",
  BondingCurveSale: "BondingCurveSale"
};
const SellActionTypenames = {
  BondingCurveSold: "BondingCurveSold"
};
const LikeActionType = {
  USER_LIKED_RELEASE: "USER_LIKED_RELEASE",
  USER_UNLIKED_RELEASE: "USER_UNLIKED_RELEASE",
  USER_LIKED_PLAYLIST: "USER_LIKED_SHELF",
  USER_UNLIKED_PLAYLIST: "USER_UNLIKED_SHELF"
};
const LikeActionTypenames = {
  ReleaseLiked: "ReleaseLiked",
  ReleaseUnliked: "ReleaseUnliked"
};
const ExposedLikeActionType = {
  [LikeActionType.USER_LIKED_RELEASE]: LikeActionType.USER_LIKED_RELEASE,
  [LikeActionType.USER_UNLIKED_RELEASE]: LikeActionType.USER_UNLIKED_RELEASE
};
const parseExposedLikeActionType = enumParser(ExposedLikeActionType);
const LIKE_ACTION_TO_TYPENAME = {
  [LikeActionType.USER_LIKED_RELEASE]: LikeActionTypenames.ReleaseLiked,
  [LikeActionType.USER_UNLIKED_RELEASE]: LikeActionTypenames.ReleaseUnliked
};
const PlaylistActionTypenames = {
  ReleasesAddedToPlaylist: "ReleasesAddedToPlaylist",
  ReleasesRemovedFromPlaylist: "ReleasesRemovedFromPlaylist",
  ReleasesAddedRemovedFromPlaylist: "ReleasesAddedRemovedFromPlaylist",
  PlaylistLiked: "PlaylistLiked",
  PlaylistCreated: "PlaylistCreated",
  [LikeActionTypenames.ReleaseUnliked]: LikeActionTypenames.ReleaseUnliked,
  [PostActionTypenames.CreatedPlaylistPost]: PostActionTypenames.CreatedPlaylistPost
};
const PLAYLIST_ACTION_TO_TYPENAME = {
  [LikeActionType.USER_LIKED_PLAYLIST]: PlaylistActionTypenames.PlaylistLiked,
  [ShelfActionType.CREATED_SHELF]: PlaylistActionTypenames.PlaylistCreated,
  [ShelfActionType.ADDED_RELEASE_TO_SHELF]: PlaylistActionTypenames.ReleasesAddedToPlaylist,
  [ShelfActionType.REMOVE_RELEASE_FROM_SHELF]: PlaylistActionTypenames.ReleasesRemovedFromPlaylist,
  [ShelfActionType.REMOVED_RELEASE_FROM_SHELF]: PlaylistActionTypenames.ReleasesRemovedFromPlaylist,
  [ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF]: PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist,
  [PostActionType.USER_CREATED_PLAYLIST_POST]: PostActionTypenames.CreatedPlaylistPost
};
const ReleaseActionTypenames = {
  [PurchaseActionTypenames.PrimarySale]: PurchaseActionTypenames.PrimarySale,
  [PurchaseActionTypenames.SecondarySale]: PurchaseActionTypenames.SecondarySale,
  [PurchaseActionTypenames.BondingCurveSale]: PurchaseActionTypenames.BondingCurveSale,
  [SellActionTypenames.BondingCurveSold]: SellActionTypenames.BondingCurveSold,
  [LikeActionTypenames.ReleaseLiked]: LikeActionTypenames.ReleaseLiked,
  [PlaylistActionTypenames.ReleasesAddedToPlaylist]: PlaylistActionTypenames.ReleasesAddedToPlaylist,
  [PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist]: PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist,
  ReleaseDropped: "ReleaseDropped",
  [PostActionTypenames.CreatedPost]: PostActionTypenames.CreatedPost
};
const CollectorActionTypenames = {
  [PlaylistActionTypenames.PlaylistLiked]: PlaylistActionTypenames.PlaylistLiked,
  [PurchaseActionTypenames.Airdrop]: PurchaseActionTypenames.Airdrop,
  [PurchaseActionTypenames.PrimarySale]: PurchaseActionTypenames.PrimarySale,
  [PurchaseActionTypenames.BondingCurveSale]: PurchaseActionTypenames.BondingCurveSale,
  [PurchaseActionTypenames.SecondarySale]: PurchaseActionTypenames.SecondarySale,
  [SellActionTypenames.BondingCurveSold]: SellActionTypenames.BondingCurveSold,
  [PlaylistActionTypenames.PlaylistCreated]: PlaylistActionTypenames.PlaylistCreated,
  [PlaylistActionTypenames.ReleasesAddedToPlaylist]: PlaylistActionTypenames.ReleasesAddedToPlaylist,
  [PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist]: PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist,
  [PlaylistActionTypenames.ReleasesRemovedFromPlaylist]: PlaylistActionTypenames.ReleasesRemovedFromPlaylist,
  [LikeActionTypenames.ReleaseLiked]: LikeActionTypenames.ReleaseLiked,
  [PostActionTypenames.CreatedPost]: PostActionTypenames.CreatedPost,
  [PostActionTypenames.CreatedPlaylistPost]: PostActionTypenames.CreatedPlaylistPost
};
const NftActionType = {
  USER_PURCHASED_NFT: "USER_PURCHASED_NFT",
  USER_SOLD_BONDING_CURVE_NFT: "USER_SOLD_BONDING_CURVE_NFT"
};
const DraftActionType = {
  CREATE_DRAFT: "CREATE_DRAFT",
  UPDATE_DRAFT: "UPDATE_DRAFT",
  DELETE_DRAFT: "DELETE_DRAFT",
  MINT_DRAFT: "MINT_DRAFT"
};
const NftActionTag = {
  PRIMARY_SALE: "PRIMARY_SALE",
  SECONDARY_SALE: "SECONDARY_SALE",
  BONDING_CURVE_SALE: "BONDING_CURVE_SALE",
  // aka 'SAM' mint
  AIRDROP: "AIRDROP",
  TRANSFER: "TRANSFER",
  ALBUM_PRE_REVEAL_PRIMARY_SALE: "ALBUM_PRE_REVEAL_PRIMARY_SALE"
};
const ActivityFeedGroupPurchaseCollectionType = {
  [NftActionTag.AIRDROP]: NftActionTag.AIRDROP,
  [NftActionTag.PRIMARY_SALE]: NftActionTag.PRIMARY_SALE,
  [NftActionTag.SECONDARY_SALE]: NftActionTag.SECONDARY_SALE,
  [NftActionTag.BONDING_CURVE_SALE]: NftActionTag.BONDING_CURVE_SALE
};
const parseActivityFeedGroupPurchaseCollectionType = enumParser(
  ActivityFeedGroupPurchaseCollectionType
);
const isActivityFeedGroupPurchaseCollectionType = enumChecker(
  ActivityFeedGroupPurchaseCollectionType
);
const ExposedCollectorActionType = {
  [ShelfActionType.ADDED_RELEASE_TO_SHELF]: ShelfActionType.ADDED_RELEASE_TO_SHELF,
  [ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF,
  [ShelfActionType.REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.REMOVED_RELEASE_FROM_SHELF,
  [ShelfActionType.REMOVE_RELEASE_FROM_SHELF]: ShelfActionType.REMOVE_RELEASE_FROM_SHELF,
  // This is a legacy type
  [NftActionType.USER_PURCHASED_NFT]: NftActionType.USER_PURCHASED_NFT,
  [NftActionType.USER_SOLD_BONDING_CURVE_NFT]: NftActionType.USER_SOLD_BONDING_CURVE_NFT,
  [ShelfActionType.CREATED_SHELF]: ShelfActionType.CREATED_SHELF,
  [LikeActionType.USER_LIKED_RELEASE]: LikeActionType.USER_LIKED_RELEASE,
  [LikeActionType.USER_LIKED_PLAYLIST]: LikeActionType.USER_LIKED_PLAYLIST,
  [PostActionType.USER_CREATED_POST]: PostActionType.USER_CREATED_POST,
  [PostActionType.USER_CREATED_PLAYLIST_POST]: PostActionType.USER_CREATED_PLAYLIST_POST
};
const parseExposedCollectorActionType = enumParser(
  ExposedCollectorActionType
);
const ReleaseActionType = {
  USER_ADDED_RELEASE: "USER_ADDED_RELEASE",
  EDIT_RELEASE: "EDIT_RELEASE"
};
const ExposedReleaseActionType = {
  [LikeActionType.USER_LIKED_RELEASE]: LikeActionType.USER_LIKED_RELEASE,
  [ShelfActionType.ADDED_RELEASE_TO_SHELF]: ShelfActionType.ADDED_RELEASE_TO_SHELF,
  [ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF,
  [NftActionType.USER_PURCHASED_NFT]: NftActionType.USER_PURCHASED_NFT,
  [NftActionType.USER_SOLD_BONDING_CURVE_NFT]: NftActionType.USER_SOLD_BONDING_CURVE_NFT,
  [ReleaseActionType.USER_ADDED_RELEASE]: ReleaseActionType.USER_ADDED_RELEASE,
  [PostActionType.USER_CREATED_POST]: PostActionType.USER_CREATED_POST
};
const parseExposedReleaseActionType = enumParser(
  ExposedReleaseActionType
);
const SubscriptionActivityFeedGroupTypenames = {
  SubscriptionUpdatedActivityFeedGroup: "SubscriptionUpdatedActivityFeedGroup",
  SubscriptionNewActivityFeedGroup: "SubscriptionNewActivityFeedGroup"
};
const ACTIVITY_FEED_GROUP_COMPONENT_TYPE_TO_TYPENAME = {
  [ActivityFeedGroupComponentTypeEnum.SONG_COLLECTED_BY_MANY]: ActivityFeedGroupInfoTypenames.SongCollectedByManyAggregate,
  [ActivityFeedGroupComponentTypeEnum.USER_COLLECTED_MANY_SONGS]: ActivityFeedGroupInfoTypenames.UserCollectedManySongsAggregate,
  [ActivityFeedGroupComponentTypeEnum.USER_PURCHASED_SECONDARY_MANY_SONGS]: ActivityFeedGroupInfoTypenames.UserCollectedManySongsAggregate,
  [ActivityFeedGroupComponentTypeEnum.SHELF_CREATED]: ActivityFeedGroupInfoTypenames.ShelfCreatedAggregate,
  [ActivityFeedGroupComponentTypeEnum.RELEASES_ADDED_TO_SHELF]: ActivityFeedGroupInfoTypenames.ReleasesAddedToShelfAggregate,
  [ActivityFeedGroupComponentTypeEnum.RELEASE_DROPPED]: ActivityFeedGroupInfoTypenames.ReleaseDroppedAggregate,
  [ActivityFeedGroupComponentTypeEnum.USER_LIKED_PLAYLIST]: ActivityFeedGroupInfoTypenames.UserLikedPlaylistAggregate,
  [ActivityFeedGroupComponentTypeEnum.USER_LIKED_SONGS]: ActivityFeedGroupInfoTypenames.UserLikedSongsAggregate,
  [ActivityFeedGroupComponentTypeEnum.USER_CREATED_POST]: ActivityFeedGroupInfoTypenames.UserCreatedPostAggregate
};
const PostActionTag = {
  SKIP_SOFT_RELEASE_REMOVE: "SKIP_SOFT_RELEASE_REMOVE"
};
const ShelfActionsToPropagateToFeed = [
  ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF,
  ShelfActionType.ADDED_RELEASE_TO_SHELF
];
const parseContractType = enumParser(ContractTypeEnum);
const SaleScheduleFlagType = {
  OPEN_EDITION_ENABLED: "OPEN_EDITION_ENABLED"
};
const VersionStatusResponseTypenames = {
  SupportedVersion: "SupportedVersion",
  NotSupportedVersion: "NotSupportedVersion"
};
const AuctionTypenames = {
  FixedAuction: "FixedAuction",
  RangeBoundAuction: "RangeBoundAuction",
  OpenEditionAuction: "OpenEditionAuction",
  OpenEditionWithSAMAuction: "OpenEditionWithSAMAuction"
};
const DraftAllowlistInfoTypenames = {
  ArtistCollectorsAllowlist: "ArtistCollectorsAllowlist",
  ReleaseCollectorsAllowlist: "ReleaseCollectorsAllowlist",
  ManuallyAddedCollectorsAllowlist: "ManuallyAddedCollectorsAllowlist"
};
const DraftAllowlistTypeEnum = {
  ARTIST_COLLECTORS: "ARTIST_COLLECTORS",
  RELEASE_COLLECTORS: "RELEASE_COLLECTORS",
  MANUALLY_ADDED_COLLECTORS: "MANUALLY_ADDED_COLLECTORS"
};
const DRAFT_ALLOWLIST_TYPE_TO_TYPENAME = {
  [DraftAllowlistTypeEnum.ARTIST_COLLECTORS]: DraftAllowlistInfoTypenames.ArtistCollectorsAllowlist,
  [DraftAllowlistTypeEnum.RELEASE_COLLECTORS]: DraftAllowlistInfoTypenames.ReleaseCollectorsAllowlist,
  [DraftAllowlistTypeEnum.MANUALLY_ADDED_COLLECTORS]: DraftAllowlistInfoTypenames.ManuallyAddedCollectorsAllowlist
};
const ArtistCollectorTypenames = {
  TopCollector: "TopCollector",
  EarliestCollector: "EarliestCollector"
};
const AllowlistSourceType = {
  MANUAL: "MANUAL",
  UNKNOWN: "UNKNOWN",
  ARTIST_SOUND_HOLDER: "ARTIST_SOUND_HOLDER"
};
const parseAllowlistSourceType = enumParser(
  AllowlistSourceType,
  "UNKNOWN"
);
const DraftAllowlistSaleTypeEnum = {
  PRESALE: "PRESALE",
  FREE_SALE: "FREE_SALE"
};
const AllowlistTypeEnum = {
  MANUALLY_ADDED: "MANUALLY_ADDED",
  ARTIST_COLLECTORS: "ARTIST_COLLECTORS",
  RELEASE_COLLECTORS: "RELEASE_COLLECTORS"
};
const AutomatedAllowlistTypeEnum = {
  [AllowlistTypeEnum.ARTIST_COLLECTORS]: AllowlistTypeEnum.ARTIST_COLLECTORS,
  [AllowlistTypeEnum.RELEASE_COLLECTORS]: AllowlistTypeEnum.RELEASE_COLLECTORS
};
const ArtistActionTypenames = {
  [LikeActionTypenames.ReleaseLiked]: LikeActionTypenames.ReleaseLiked,
  [LikeActionTypenames.ReleaseUnliked]: LikeActionTypenames.ReleaseUnliked,
  [PlaylistActionTypenames.PlaylistLiked]: PlaylistActionTypenames.PlaylistLiked,
  [ReleaseActionTypenames.ReleaseDropped]: ReleaseActionTypenames.ReleaseDropped,
  [PurchaseActionTypenames.PrimarySale]: PurchaseActionTypenames.PrimarySale,
  [PurchaseActionTypenames.BondingCurveSale]: PurchaseActionTypenames.BondingCurveSale,
  [PurchaseActionTypenames.SecondarySale]: PurchaseActionTypenames.SecondarySale,
  [PlaylistActionTypenames.PlaylistCreated]: PlaylistActionTypenames.PlaylistCreated,
  [SellActionTypenames.BondingCurveSold]: SellActionTypenames.BondingCurveSold,
  [PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist]: PlaylistActionTypenames.ReleasesAddedRemovedFromPlaylist,
  [PlaylistActionTypenames.ReleasesAddedToPlaylist]: PlaylistActionTypenames.ReleasesAddedToPlaylist,
  [PostActionTypenames.CreatedPost]: PostActionTypenames.CreatedPost,
  [PostActionTypenames.CreatedPlaylistPost]: PostActionTypenames.CreatedPlaylistPost
};
const ExposedArtistActionType = {
  [LikeActionType.USER_LIKED_PLAYLIST]: LikeActionType.USER_LIKED_PLAYLIST,
  [ReleaseActionType.USER_ADDED_RELEASE]: ReleaseActionType.USER_ADDED_RELEASE,
  [NftActionType.USER_PURCHASED_NFT]: NftActionType.USER_PURCHASED_NFT,
  // Multiple purchase activities are grouped under this one action
  [ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF]: ShelfActionType.ADDED_AND_REMOVED_RELEASE_FROM_SHELF,
  [ShelfActionType.ADDED_RELEASE_TO_SHELF]: ShelfActionType.ADDED_RELEASE_TO_SHELF,
  [ShelfActionType.CREATED_SHELF]: ShelfActionType.CREATED_SHELF,
  [LikeActionType.USER_LIKED_RELEASE]: LikeActionType.USER_LIKED_RELEASE,
  [NftActionType.USER_SOLD_BONDING_CURVE_NFT]: NftActionType.USER_SOLD_BONDING_CURVE_NFT,
  [PostActionType.USER_CREATED_POST]: PostActionType.USER_CREATED_POST,
  [PostActionType.USER_CREATED_PLAYLIST_POST]: PostActionType.USER_CREATED_PLAYLIST_POST
};
const parseExposedArtistActionType = enumParser(ExposedArtistActionType);
const PlatformEnum = {
  IOS: "IOS",
  ANDROID: "ANDROID",
  WEB: "WEB"
};
function enumParser(enumObject, fallbackValue) {
  const valuesList = Object.values(enumObject);
  const valuesMap = valuesList.reduce(
    (acum, value) => {
      acum[value] = value;
      return acum;
    },
    {}
  );
  return function parseEnum(value) {
    const enumValue = typeof value === "string" ? valuesMap[value] : null;
    if (enumValue)
      return enumValue;
    if (fallbackValue)
      return fallbackValue;
    throw Error(
      `Invalid enum value: ${JSON.stringify(
        value
      )}, possible values: ${valuesList.join()}`
    );
  };
}
function enumChecker(enumObject) {
  const checkMap = Object.values(enumObject).reduce(
    (acum, value) => {
      acum[value] = true;
      return acum;
    },
    {}
  );
  return function isEnum(value) {
    return typeof value === "string" && !!checkMap[value];
  };
}
function enumMapper(mapper) {
  return mapper;
}
function createEnum(values) {
  return values.reduce((acc, value) => {
    acc[value] = value;
    return acc;
  }, {});
}
function enumKeys(enumValue) {
  return Object.keys(enumValue);
}
const PlaylistChartType = {
  ONE_WEEK: "ONE_WEEK"
};
const parsePlaylistChartType = enumParser(PlaylistChartType);
const isPlaylistChartType = enumChecker(PlaylistChartType);
const ReleaseChartType = {
  ONE_WEEK: "ONE_WEEK",
  ONE_DAY: "ONE_DAY"
};
const parseReleaseChartType = enumParser(ReleaseChartType);
const isReleaseChartType = enumChecker(ReleaseChartType);
const InternalChain = {
  MAINNET: "MAINNET",
  GOERLI: "GOERLI",
  OPTIMISM: "OPTIMISM",
  OPTIMISM_GOERLI: "OPTIMISM_GOERLI"
};
const InternalChainTypeParser = enumParser(InternalChain);
const L2InternalChain = {
  OPTIMISM: "OPTIMISM",
  OPTIMISM_GOERLI: "OPTIMISM_GOERLI"
};
const L2InternalChainTypeParser = enumParser(InternalChain);
const ReleaseFeaturedStatus = {
  HOT: "HOT",
  ALL: "ALL"
};
const AudioFingerprintingService = {
  ACR_CLOUD: "ACR_CLOUD",
  MAGIC_AUDIBLE: "MAGIC_AUDIBLE"
};
const TierScheduleMode = {
  DEFAULT: "DEFAULT",
  VERIFY_MERKLE: "VERIFY_MERKLE",
  VERIFY_SIGNATURE: "VERIFY_SIGNATURE"
};
const TierScheduleModeTypeParser = enumParser(TierScheduleMode);

export { ACTIVITY_FEED_GROUP_COMPONENT_TYPE_TO_TYPENAME, ACTIVITY_FEED_GROUP_FILTER_OPTION_TO_COMPONENT_TYPE, ActivityFeedGroupComponentTypeEnum, ActivityFeedGroupInfoTypenames, ActivityFeedGroupPurchaseCollectionType, ActivityFeedGroupTypeFilterOptionEnum, ActivityFeedTypeEnum, AllowlistSourceType, AllowlistTypeEnum, ArtistActionTypenames, ArtistActivityFeedActivityTypeFilterOptionEnum, ArtistActivityFeedTypeFilterOptionEnum, ArtistCollectorTypenames, ArtistCommunityTypeEnum, ArtistMintedReleasesAuthorFilterOptionEnum, ArtistMintedReleasesCreditSplitFilterOptionEnum, ArtistReleasesAuthorFilterOptionEnum, ArtistReleasesCreditSplitFilterOptionEnum, ArweaveActionType, AuctionTypeEnum, AuctionTypeParser, AuctionTypenames, AudioFingerprintingService, AutomatedAllowlistTypeEnum, CollectorActionTypenames, ContractProcessorTypeEnum, ContractTypeEnum, DRAFT_ALLOWLIST_TYPE_TO_TYPENAME, DraftActionType, DraftAllowlistInfoTypenames, DraftAllowlistSaleTypeEnum, DraftAllowlistTypeEnum, EventTypeEnum, ExposedArtistActionType, ExposedCollectorActionType, ExposedLikeActionType, ExposedReleaseActionType, ExposedShelfActionType, ForYouFeedGroupComponentsFromUserFeed, InternalChain, InternalChainTypeParser, L2InternalChain, L2InternalChainTypeParser, LIKE_ACTION_TO_TYPENAME, LicenseTypeEnum, LikeActionType, LikeActionTypenames, MediaTypeEnum, MintTimeStatusEnum, MintingAccessConfigMintingTypeEnum, MintingTypes, NftActionTag, NftActionType, PLAYLIST_ACTION_TO_TYPENAME, PlatformEnum, PlaylistActionType, PlaylistActionTypenames, PlaylistChartType, PostActionTag, PostActionType, PostActionTypenames, PurchaseActionTypenames, RELEASE_STATUS_NAMES, RELEASE_TYPE_TO_CONTRACT_TYPE, ReleaseActionType, ReleaseActionTypenames, ReleaseActivityFeedTypeFilterOptionEnum, ReleaseAlbumRevealFilterOptionEnum, ReleaseChartType, ReleaseFeaturedStatus, ReleaseStatusEnum, ReleaseTypeEnum, SaleScheduleFlagType, SellActionTypenames, ShelfActionType, ShelfActionsToPropagateToFeed, ShelfTypeEnum, ShelfTypeFilterEnum, ShelfTypeParser, SongKeyEnum, SubscriptionActivityFeedGroupTypenames, TierScheduleMode, TierScheduleModeTypeParser, TieredAuctionTypeEnum, TimePeriodAggEnum, TopChartTimePeriodEnum, TrendingArtistsSortEnum, TrendingCollectorsSortEnum, TrendingPlaylistsSortEnum, TrendingReleasesSortEnum, VersionStatusResponseTypenames, createEnum, enumChecker, enumKeys, enumMapper, enumParser, isActivityFeedGroupPurchaseCollectionType, isLicenseTypeEnum, isPlaylistChartType, isReleaseChartType, isSongKeyEnum, parseActivityFeedGroupComponentType, parseActivityFeedGroupPurchaseCollectionType, parseAllowlistSourceType, parseContractType, parseEventType, parseExposedArtistActionType, parseExposedCollectorActionType, parseExposedLikeActionType, parseExposedReleaseActionType, parseExposedShelfActionType, parseMintingAccessConfigMintingType, parsePlaylistChartType, parseReleaseChartType, parseReleaseType, parseShelfActionType };
